import { UserCreateDto } from '@lucidlink/dto/web-service-api';
import { base64ToArray, encryptWithAes } from '@lucidlink/ts-crypto/crypto';
import { generateScramRecord, } from '@lucidlink/ts-crypto/scram';
import { preparePasswordUserCrypto } from './prepare-user-crypto';
const preparePendingInvitationDto = async (userKey, invitationData) => {
    if (!invitationData) {
        return undefined;
    }
    const invitationSecret = base64ToArray(invitationData.linkSecret);
    const eLinkSecretByUserKey = await encryptWithAes(invitationSecret, userKey);
    return {
        invitationId: invitationData.id,
        eLinkSecretByUserKey,
    };
};
export const prepareRegisterUserDto = async ({ email, password, invitationData, }) => {
    const scramRecord = await generateScramRecord(password);
    const userCrypto = await preparePasswordUserCrypto(password);
    const userRequest = {
        email,
        pendingInvitation: await preparePendingInvitationDto(userCrypto.cryptoKey, invitationData),
        userIdentity: {
            scramIterations: scramRecord.iterations,
            scramSalt: scramRecord.salt,
            scramStoredKey: scramRecord.storedKey,
            userCryptoKey: userCrypto.wrappedCryptoKeyB64,
            userCryptoKeySalt: userCrypto.salt,
            userCryptoKeyIterations: userCrypto.iterations,
        },
    };
    return UserCreateDto.create(userRequest);
};
